import * as React from 'react';

import { rest } from '@app/components/Api';

import Musthead from '@app/components/UI/MustHead/Musthead';
import FiftyFifty from '@app/components/UI/FiftyFifty/FiftyFifty';
import { angelBlockRichTitle, angelFundFiftyText, angelFundFiftyTitle, mustheadText } from '@app/components/Pages/AngelFund/angelFundContent';
import BlockRich from '@app/components/UI/LinkBlock/BlockRich';
import img1 from '@app/content/Dr.Rachel.jpg';
import img2 from '@app/content/Yvonne and Ranger.jpg';
import img3 from '@app/content/Dr.Dani.png';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';

import '@app/scss/components/angelFund.scss';

interface AngelFundContent {
	header: string;
	smallHeader: string;
	block1Text: string;
	block2Text: string;
}

const AngelFund: React.FC = () => {
	const [content, setContent] = React.useState<AngelFundContent>({
		header: 'Angel Fund',
		smallHeader: mustheadText,
		block1Text: angelFundFiftyText,
		block2Text:
			"One of the amazing aspects of the human-animal bond is the fact that it never seems to go away. No matter how long it been since a beloved pet has passed, we remember them, their quirks, and their cuteness like it was yesterday. So when you donate to the Angel Fund to help families and their pets, you're not just donating to support a single passing moment in time—you're donating to an experience that will stay in people’s hearts and minds forever, a moment of immeasurable importance with an impact they’ll feel for the rest of their lives.",
	});

	const url = 'https://www.paypal.com/donate/?cmd=_s-xclick&hosted_button_id=X9CSF2LY7DG84';

	const openInNewTab = (arg) => {
		const win = window.open(arg, '_blank');
		win && win.focus();
	};

	React.useEffect(() => {
		rest.get<AngelFundContent>('v1/content/angel fund').then(res => res && setContent(res));
	}, []);

	return (
		<div className="angel-fund">
			<Musthead
				title={content.header}
				imageSrc={require('@app/content/angel_fund.png')}
				text={content.smallHeader}
				buttonText="Donate today"
				btnPath={url}
				onBtnClick={openInNewTab}
				to="/angel-fund"
				imageAlt="Angel fund"
				other={
					<div className="angel-fund__other">
						* All donations to Lap of Love’s Angel Fund go toward families and pets in need; however, donations are not tax deductible.
					</div>
				}
			/>
			<FiftyFifty
				title={angelFundFiftyTitle}
				text={
					<>
						<p>{content.block1Text}</p>
						<p style={{ fontStyle: 'italic' }}>
							*The Angel Fund is a limited resource only dispersed at Lap of Love's discretion depending on the severity of the need.
						</p>
					</>
				}
				src={require('@app/content/angel_fund_fifty.png')}
				btnText="Become an angel"
				btnPath={url}
				reversed
				openInNewTab={openInNewTab}
				alt="Lap of Love donation"
			/>

			<BlockRich
				title={angelBlockRichTitle}
				text={content.block2Text}
				images={[
					{ title: 'Dr. Rachel', src: img1, alt: 'Lap of Love Veterinary Hospice' },
					{ title: 'Dr. Dani', src: img3, alt: 'Pet Loss Support Group' },
					{ title: 'Yvonne and Ranger', src: img2, alt: 'End of life geriatric pet' },
				]}
				buttonCaption="Make an impact"
				link={url}
			/>
		</div>
	);
};

export default withSeo(AngelFund, state => state.angelFundPage, 'angelFundPage', 'angel-fund');
